import { ModeEnum } from '@/store/modules/settings/types'

interface HomeListItem {
  id: number
}

interface HomeStatsItem {
  id: number
  countStay: number
  countTodoStay: number
}

export function updateHomeList(storedList: HomeStatsItem[], responseList: HomeListItem[], responseStats: HomeStatsItem[]): HomeListItem[] {
  const updatedItems = storedList.map((storedItem) => {
    const responseItem = responseList.find((item) => item.id === storedItem.id)
    // note: no stats for a fetched item means that count are at 0
    const stats = responseStats.find((stat) => stat.id === storedItem.id)
            ?? (responseItem ? { countStay: 0, countTodoStay: 0 } : { countStay: storedItem.countStay, countTodoStay: storedItem.countTodoStay })
    return responseItem ? { ...responseItem, ...stats } : storedItem
  })

  const newItems = responseList.filter((responseItem) => {
    return !updatedItems.some((item) => item.id === responseItem.id)
  }).map((newItem) => {
    const stats = responseStats.find((stat) => stat.id === newItem.id)
            ?? { countStay: 0, countTodoStay: 0 }
    return { ...newItem, ...stats }
  })

  return updatedItems.concat(newItems)
}

export function savedSearchLabels(mode: ModeEnum): { singular: string, plural: string } {
  return mode === ModeEnum.NEW_CODING
    ? { singular: 'liste de travail', plural: 'listes de travail' }
    : { singular: 'recherche', plural: 'recherches' }
}

// la dialyse suit les mêmes règles de partage que le contrôle qualité
export function canShareWithTeam(mode: ModeEnum): boolean {
  return [ModeEnum.OPTIMIZABLE, ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS].includes(mode)
}

export function canShareWithSancare(mode: ModeEnum): boolean {
  return ![ModeEnum.QUALITY_STAYS, ModeEnum.DIALYSIS].includes(mode)
}
